import { render, staticRenderFns } from "./NominationConferenceCreate.vue?vue&type=template&id=994ce01a"
import script from "./NominationConferenceCreate.vue?vue&type=script&lang=js"
export * from "./NominationConferenceCreate.vue?vue&type=script&lang=js"
import style0 from "./NominationConferenceCreate.vue?vue&type=style&index=0&id=994ce01a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports